import { Section } from 'components/Section';
import { NO_ELEMENT, hasElements } from 'utils';
import { ProductsCardGrid } from './productsCardGrid';
import { TopSellersInCategoryBlock } from 'models/TopSellersInCategoryBlock';

export const TopSellersInCategory = ({ title, products }: TopSellersInCategoryBlock) => {
  if (!hasElements(products)) {
    return NO_ELEMENT;
  }

  return (
    <Section title={title}>
      <ProductsCardGrid products={products} />
    </Section>
  );
};
